import {useSelector} from "react-redux";

import {IABTestingState} from "../types/IABTestingState";
import {abTestingSelector} from "../utils/ab_testing_selector";

export const useABTestVariant = (abTestId: string): number | null => {
    const forcedVariant = useSelector((state: IABTestingState) => state.abTesting.forcedVariant);
    return forcedVariant ?? useSelector(abTestingSelector(abTestId)) ?? null;
};
import {useSelector} from "react-redux";

import {IABTestingState} from "../types/IABTestingState";
import {abTestingSelector} from "../utils/ab_testing_selector";

export const useABTestVariant = (abTestId: string): number | null => {
    const forcedVariant = useSelector((state: IABTestingState) => state.abTesting.forcedVariant);
    return forcedVariant ?? useSelector(abTestingSelector(abTestId)) ?? null;
};
